import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-weighting-animation',
  templateUrl: './weighting-animation.component.html',
  styleUrls: ['./weighting-animation.component.scss'],
  standalone: false,
})
export class WeightingAnimationComponent implements OnInit {
  @Input() classExpression: string;

  ngOnInit() {}
}
